var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHumanArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3ZM7 7C7 5.89543 7.89543 5 9 5C10.1046 5 11 5.89543 11 7C11 8.10457 10.1046 9 9 9C7.89543 9 7 8.10457 7 7Z",
    fill: "#7B61FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 21C3 17.6863 5.68629 15 9 15C12.3137 15 15 17.6863 15 21H17C17 16.5817 13.4183 13 9 13C4.58172 13 1 16.5817 1 21H3Z",
    fill: "#7B61FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5857 13L17.7928 14.7928L19.2071 16.207L22.7071 12.707C23.0976 12.3165 23.0976 11.6833 22.7071 11.2928L19.2071 7.79282L17.7928 9.20703L19.5858 11H14.9969V13H19.5857Z",
    fill: "#7B61FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumanArrowRight);
export default __webpack_public_path__ + "static/media/human-arrow-right.2ea951d73c8fce5020755db2e0647aaa.svg";
export { ForwardRef as ReactComponent };